import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";
import BaseModal from ".";

const GridProduct = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 8px;
`;

const ProductTitle = styled(Typography)`
  color: #000;
  font-weight: 500;
  align-self: center;
`;

export type ModalInfoMoreProps = {
  open: boolean;
  onClose: () => void;
  productImage: string;
  productName: string;
  description: string;
};

const ModalInfoMore = ({
  open,
  onClose,
  productImage,
  productName,
  description,
}: ModalInfoMoreProps) => {

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={
        <GridProduct>
          <img
            loading="lazy"
            height={91}
            alt="logo kaspersky"
            src={productImage}
          ></img>
          <ProductTitle variant="h6">{productName}</ProductTitle>
        </GridProduct>
      }
      body={
        <div>
          <Typography
            color="primary"
            variant="subtitle1"
            style={{ fontWeight: 400, color: "#000" }}
          >
            {description}
          </Typography>
        </div>
      }
      footer={
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Button
            fullWidth
            variant="contained"
            style={{
              backgroundColor: '#15997B',
            }}

            onClick={onClose}
          >
            Voltar
          </Button>
        </div>
      }
    />
  );
};
export default ModalInfoMore;
